import { motion } from "motion/react";

const reasons = [
  {
    emoji: "⚡",
    title: "Rapidez: visita en 24h",
    text: "Te respondemos el mismo día y visitamos tu hogar en menos de 24 horas.",
  },
  {
    emoji: "💰",
    title: "Presupuesto gratis sin compromiso",
    text: "Te damos precio claro y honesto antes de empezar. Sin sorpresas.",
  },
  {
    emoji: "🛡️",
    title: "Garantía 2 años",
    text: "Todas nuestras instalaciones y reparaciones llevan garantía de 2 años.",
  },
  {
    emoji: "📍",
    title: "Empresa local desde 2015",
    text: "Más de 10 años reparando persianas en Málaga. Conocemos cada barrio de la Costa del Sol.",
  },
];

export default function WhyUsSection() {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-container mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary">
            ¿Por qué elegirnos?
          </h2>
        </div>

        <motion.div
          className="border border-border rounded-3xl p-6 md:p-10 bg-white"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6 }}
        >
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {reasons.map((r, i) => (
              <div key={r.title} className="text-center">
                <div className="text-4xl mb-3">{r.emoji}</div>
                <h3 className="font-heading font-bold text-xl text-text-primary mb-2">
                  {r.title}
                </h3>
                <div className="w-6 h-0.5 bg-primary mx-auto mb-3 rounded-full"></div>
                <p className="font-body text-[15px] text-text-secondary leading-relaxed">
                  {r.text}
                </p>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}